import { WEB_LOCALES } from '@/constants/web-locales.constant';
import { WebLocale } from '@/enums/web-locale';
import { getSlotPath, loadAdYieldlove, yieldloveWebLocales } from '@/helpers/ad/yieldlove-helper';
import { AdsenseHelper } from './adsense-helper';
import { loadGAM } from './gam-helper';

export const enum AdProvider {
	YIELDLOVE = 'yieldlove',
	ADSENSE = 'adsense',
	GAM = 'GAM',
}

export const AdProviderLocales: { [key: string]: AdProvider } = Object.keys(WEB_LOCALES).reduce((root, webLocale) => {
	(root as any)[webLocale] = getProviderByCountry(webLocale as WebLocale);
	return root;
}, {} as Record<keyof typeof WEB_LOCALES, AdProvider>);

export const SNIGEL_EXP_COUNTRIES = ['AU', 'DE', 'GB', 'US', 'TR', 'IN'];

export const adSlots = [
	// {
	// 	name: 'jw_{WEBLOCALE}_top',
	// 	path: '/21679119891/jw_{WEBLOCALE}_top',
	// 	sizes: [
	// 		{ x: 320, y: 50, breakpoint: 310, adsenseSlot: 5594148909 },
	// 		{ x: 728, y: 90, breakpoint: 825, adsenseSlot: 2516381812 },
	// 	],
	// },
	{
		name: 'jw_{WEBLOCALE}_inlist_1',
		path: '/21679119891/jw_{WEBLOCALE}_inlist_1',
		gamPath: '/21679119891/new_inlist_1',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_inlist_2',
		path: '/21679119891/jw_{WEBLOCALE}_inlist_2',
		gamPath: '/21679119891/new_inlist_2',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_inlist_3',
		path: '/21679119891/jw_{WEBLOCALE}_inlist_3',
		gamPath: '/21679119891/new_inlist_3',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_under_detail_info',
		path: '/21679119891/jw_{WEBLOCALE}_under_detail_info',
		gamPath: '/21679119891/title_under_detail_info',
		sizes: [{ x: 300, y: 600, breakpoint: 992, adsenseSlot: 9468572974 }],
	},
	{
		name: 'jw_{WEBLOCALE}_under_buybox',
		path: '/21679119891/jw_{WEBLOCALE}_under_buybox',
		gamPath: '/21679119891/title_under_buybox',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 728, y: 90, breakpoint: 1130, adsenseSlot: 2516381812 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_bottom_page',
		path: '/21679119891/jw_{WEBLOCALE}_bottom_page',
		gamPath: '/21679119891/title_bottom_page',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 728, y: 90, breakpoint: 1130, adsenseSlot: 2516381812 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_sport_under_offers',
		// path: '/21679119891/jw_{WEBLOCALE}_sport_under_offers',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 728, y: 90, breakpoint: 1130, adsenseSlot: 2516381812 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_sport_under_details',
		// path: '/21679119891/jw_{WEBLOCALE}_sport_under_details',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 728, y: 90, breakpoint: 1130, adsenseSlot: 2516381812 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_sport_inlist_1',
		// path: '/21679119891/jw_{WEBLOCALE}_sport_inlist_1',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_sport_inlist_2',
		// path: '/21679119891/jw_{WEBLOCALE}_sport_inlist_2',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_sport_inlist_3',
		// path: '/21679119891/jw_{WEBLOCALE}_sport_inlist_3',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_sport_inlist_4',
		// path: '/21679119891/jw_{WEBLOCALE}_sport_inlist_4',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_sport_inlist_5',
		// path: '/21679119891/jw_{WEBLOCALE}_sport_inlist_5',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_sport_inlist_6',
		// path: '/21679119891/jw_{WEBLOCALE}_sport_inlist_6',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
	{
		name: 'jw_{WEBLOCALE}_sport_inlist_7',
		// path: '/21679119891/jw_{WEBLOCALE}_sport_inlist_7',
		sizes: [
			{ x: 300, y: 250, breakpoint: 310, adsenseSlot: 2488461659 },
			{ x: 970, y: 250, breakpoint: 1106, adsenseSlot: 1566723844 },
		],
	},
];

function getProviderByCountry(webLocale: WebLocale): AdProvider {
	if (yieldloveWebLocales.includes(webLocale)) {
		return AdProvider.YIELDLOVE;
	}
	if ([WebLocale.uk, WebLocale.fr, WebLocale.es, WebLocale.de, WebLocale.it].includes(webLocale)) {
		return AdProvider.GAM;
	}
	return AdProvider.ADSENSE;
}
type GeneralSize = 'fluid' | number[] | number[][] | any;

// Declare Google Tag (DFP) and YieldLove Variables in Window object.
declare global {
	interface GoogleSlot {
		getSlotElementId: () => string;
		setTargeting: (key: string, value: string | string[]) => GoogleSlot;
		getTargeting: (key: string) => string[];
		addService: (service: any) => GoogleSlot;
		clearTargeting: (key?: string) => GoogleSlot;
	}
	interface Window {
		// dfp
		googletag: {
			cmd: (() => void)[];
			pubads: () => {
				getSlots: () => GoogleSlot[];
				enableSingleRequest: () => void;
				disableInitialLoad: () => void;
				clear: (slots?: GoogleSlot[]) => boolean;
				refresh: (slots?: GoogleSlot[]) => void;
				addEventListener: (eventType: string, listener: (event: any) => void) => void;
				removeEventListener: (eventType: string, listener: (event: any) => void) => void;
			};
			defineSlot: (adUnitPath: string, size: GeneralSize, divId: string) => GoogleSlot | null;
			enableServices: () => void;
			display: (divId: string) => void;
			destroySlots: (slots?: GoogleSlot[]) => boolean;
		};
		// yieldlove
		YLHH: {
			bidder: any;
		};
	}
}

let servicesEnabled = false;

export function ensureGPTServicesEnabled() {
	if (servicesEnabled) return;

	window.googletag.cmd.push(() => {
		if (!servicesEnabled) {
			window.googletag.pubads().enableSingleRequest();
			window.googletag.pubads().disableInitialLoad();
			window.googletag.enableServices();
			servicesEnabled = true;
		}
	});
}

const ready$: Record<string, null | Promise<void>> = {};

export function getAdProvider(webLocale: WebLocale, isSport: boolean) {
	if (isSport) {
		return AdProvider.ADSENSE;
	}
	return AdProviderLocales[webLocale];
}

export async function whenReady(webLocale: WebLocale, adProviderSelected: AdProvider) {
	if (!ready$[adProviderSelected]) {
		switch (adProviderSelected) {
			case AdProvider.YIELDLOVE:
				ready$[AdProvider.YIELDLOVE] = new Promise<void>(
					async (resolve, reject) => await loadAdYieldlove(webLocale, resolve, reject)
				);
				break;

			case AdProvider.ADSENSE:
				ready$[AdProvider.ADSENSE] = new Promise<void>(resolve => AdsenseHelper.load(webLocale, resolve));
				break;

			case AdProvider.GAM:
				ready$[AdProvider.GAM] = new Promise<void>(resolve => loadGAM(webLocale, resolve));
				break;
		}
	}

	return ready$[adProviderSelected];
}

export async function loadAd(
	webLocale: WebLocale,
	slotId: string,
	adProviderSelected: AdProvider,
	onSlotReceived?: (filled: boolean) => void,
	targeting?: Record<string, string> | null
) {
	try {
		await whenReady(webLocale, adProviderSelected);

		switch (adProviderSelected) {
			case AdProvider.YIELDLOVE:
				if (window.YLHH && window.YLHH.bidder) {
					window.googletag.cmd.push(() => {
						if (targeting) {
							const slot = window.googletag
								.pubads()
								.getSlots()
								.find(s => s.getSlotElementId() === slotId);
							Object.entries(targeting).forEach(([key, value]) => slot?.setTargeting(key, value));
						}

						window.YLHH.bidder.startAuction(getSlotPath(webLocale, `/21679119891/${slotId}`));

						window.googletag.cmd.push(function () {
							window.googletag.display(slotId);
						});

						window.googletag.pubads().addEventListener('slotResponseReceived', (evt: any) => {
							const { slot } = evt;
							if (slotId === slot.getSlotElementId()) {
								onSlotReceived?.(slot.getResponseInformation() !== null);
							}
						});
					});
				} else {
					import('@/helpers/sentry-helper').then(({ captureMessageForSentry }) => {
						captureMessageForSentry(`[ad-helper.ts YIELDLOVE]: window.YLHH.bidder is undefined`);
					});
					onSlotReceived?.(false);
				}

				break;
			case AdProvider.ADSENSE:
				(window.adsbygoogle = window.adsbygoogle || []).push({});
				break;
			case AdProvider.GAM:
				window.googletag.cmd.push(function () {
					window.googletag.display(slotId);
				});
				break;
			default:
				break;
		}
	} catch (error: any) {
		console.error(`[Ad-Helper] Failed to load ad: ${adProviderSelected} for slot ${slotId}`, error);
		// Inform AdUnit that the slot was not filled
		onSlotReceived?.(false);
	}
}

export async function removeAd(webLocale: WebLocale, slotId: string, adProviderSelected: AdProvider) {
	await whenReady(webLocale, adProviderSelected);

	switch (adProviderSelected) {
		case AdProvider.YIELDLOVE:
			window.googletag.cmd.push(function () {
				// Find the slot object by its element ID
				const slots = window.googletag.pubads().getSlots();
				const slotToRemove = slots.find(slot => slot.getSlotElementId() === slotId);

				if (slotToRemove) {
					window.googletag.pubads().clear([slotToRemove]);
				} else {
					console.warn(`[YL] Slot not found for removal: ${slotId}`);
				}
			});
			break;
	}
}
